import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";

const CategoryDropdown = () => {
  const [categories, setCategories] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { lang } = useParams();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const query = `*[_type == "category"]{ _id, title, slug }`;
        const data = await sanityClient.fetch(query);
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const getLocalizedTitle = (titleObj) =>
    titleObj?.[lang] || titleObj?.en || "Untitled";

  return (
    <div className="relative">
      <button
        className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        {lang === "fr"
          ? "Collections"
          : lang === "es"
          ? "Colecciones"
          : lang === "ar"
          ? "المجموعات"
          : "Collections"}
      </button>

      {isDropdownOpen && (
        <ul className="absolute bg-white text-black mt-2 w-48 shadow-lg rounded-md border z-50">
          {categories.map((category) => (
            <li key={category._id} className="hover:bg-gray-100">
              <Link
                to={`/cm/${lang}/collections/${category.slug?.current}`}
                className="block px-4 py-2"
                onClick={() => setIsDropdownOpen(false)}
              >
                {getLocalizedTitle(category.title)}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryDropdown;
